import { createStorageKey, local } from '@utils/storage';

const FeatureFlagIdentifier = 'FeatureFlag';

export const isLocalFeatureFlagEnabled = (featureFlag: string): boolean => {
    const featureFlagValue = local.getItem(createStorageKey([FeatureFlagIdentifier, featureFlag]));
    return featureFlagValue === 'true';
};

export const setLocalFeatureFlag = (featureFlag: string, value: boolean): void => {
    local.setItem(createStorageKey([FeatureFlagIdentifier, featureFlag]), value.toString());
};
